import React, { useState, useEffect } from "react";
import history from "../../../routes/history";
import { Form, Input, Button, Checkbox, message, Modal } from "antd";
import {
  EyeInvisibleOutlined,
  EyeTwoTone,
  LoadingOutlined,
} from "@ant-design/icons";

import ReactGA from "react-ga4";

import { Auth } from "../../../config/aws-exports";
import { isModalVisibleAuth, userClicked } from "../../../redux/actions";
import LostPassword from "./LostPassword";

import { setCookie } from "../../../shared/helpers";
import { VscLock } from "react-icons/vsc";
import { useDispatch, useSelector } from "react-redux";

import "./SignUpLogin.css";
import GreenCheck from "../../../assets/icons/typcn_tick.svg";
import { GoAlert } from "react-icons/go";
import { APP_NAME, EVENTS, PAGE, PAGE_TYPE } from "../../../constants/userTrackingConstants";

const Login = () => {
  const getRemember = JSON.parse(localStorage.getItem("rememberMe"));
  let initialValue = !getRemember ? false : getRemember;

  const uuid = useSelector((state) => state.userTrackingReducer.uuid);

  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(false);
  const [isremember, setIsRemember] = useState(initialValue);
  const [errormessage, setErrorMessage] = useState("");

  const [greenCheck, setGreenCheck] = useState(false);
  const [showCheckIconEmail, setShowCheckIconEmail] = useState(false);

  const [greenCheckPassword, setGreenCheckPassword] = useState(false);
  const [showCheckPassword, setShowCheckPassword] = useState(false);
  const [passwordValidation, setPasswordValidation] = useState(false);

  const [isModalVisibleForgotAuth, setIsModalVisibleForgotAuth] =
    useState(false);
  const [backClicked, setBackClicked] = useState(false);

  const [email, setEmail] = useState(null);
  const [checked, setChecked] = useState(true);

  const GetPassword = localStorage.getItem("password");
  const GetEmail = localStorage.getItem("Email");

  const remember = (e) => {
    // if(e.target.checked===true){
    //   localStorage.setItem('rememberMe', true)
    // }
    // else if(e.target.checked===false){
    //   localStorage.setItem('rememberMe', false)
    // }
    setIsRemember(!isremember);
    // console.log('isRemember',isremember);
  };

  // const lostPass = () => {
  //   history.push("/forgot");
  // };
  useEffect(() => {
    const valid = /^\w+([\.-]?\w+)@\w+([\.-]?\w+)(\.\w{2,3})+$/;
    if (GetEmail?.length > 0 && initialValue === true) {
      setShowCheckIconEmail(true);
    }
    if (valid.test(GetEmail) && initialValue === true) {
      setGreenCheck(true);
    } else {
      setGreenCheck(false);
    }
  }, []);

  const forgetpassword = () => {
    if (window.innerWidth < 768) {
      history.push("/forgot");
      setIsModalVisibleForgotAuth(false);
      dispatch(isModalVisibleAuth(false));
    } else {
      showModal();
    }

    // history.push("/forgot");
  };

  const lostPassToLogin = (data) => {
    // console.log("lostpass data", data);
    if (data === "Success") {
      setTimeout(() => {
        setIsModalVisibleForgotAuth(false);
      }, 3000);
    }
  };

  // const enterEmail = <div className="enterEmail">Enter your email</div>;

  const validateEmail = (e) => {
    const email = e.target.value;
    const valid = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    if (email.length > 0) {
      setShowCheckIconEmail(true);
    }
    if (valid.test(email)) {
      setGreenCheck(true);
      setEmail(e.target.value);
    } else {
      setGreenCheck(false);
    }
  };

  const validatePassword = (e) => {
    const password = e.target.value;
    if (password.length === 0) setPasswordValidation(false);

    // const valid = /^\S{8,}$/;
    // console.log(password);

    // if (valid.test(password)) {
    //   setPasswordValidation(false);
    // } else {
    //   setPasswordValidation(true);
    // }
  };

  const onLogin = async ({ email, password }) => {
    setCount(false);
    setLoading(true);
    // console.log("Received values of form: ", values);
    // localStorage.clear('pathnameonclosing')
    localStorage.setItem("Email", email);
    localStorage.setItem("password", password);
    localStorage.setItem("rememberMe", isremember);
    try {
      const response = await Auth.signIn({ username: email, password });
      // https://serverless-idm.awssecworkshops.com/01-user-auth/#validate-sign-up-and-sign-in
      const session = await Auth.currentSession();
      // console.log('Cognito User Access Token:', session.getAccessToken().getJwtToken());
      if (isremember) {
        const result = await Auth.rememberDevice();
        if (result == "SUCCESS") {
          setCookie("RememberMe", "true");
        }
      }
      // console.log('Cognito User Refresh Token', session.getRefreshToken().getToken());
      setLoading(false);
      dispatch(isModalVisibleAuth(false));
      history.push("/auth");
    } catch (error) {
      setLoading(false);
      setCount(true);
      // message.error(error.message);
      setPasswordValidation(true);
      setTimeout(() => {
        setCount(false);
      }, 4000);
      if (isremember) {
      }
    }
  };

  const showModal = () => {
    // dispatch(isModalVisibleAuth(true));
    setIsModalVisibleForgotAuth(true);
  };
  const modalCancel = () => {
    // dispatch(isModalVisibleAuth(false));
    setIsModalVisibleForgotAuth(false);
    form.resetFields();
    setBackClicked(true);
  };

  return (
    <div className="loginSkillgigs">
      <Form
        name="normal_login"
        className="formLogin"
        initialValues={{
          remember: initialValue,
          email: initialValue ? GetEmail : "",
          password: initialValue ? GetPassword : "",
        }}
        onFinish={onLogin}
      >
        <Form.Item
          name="email"
          hasFeedback
          validateStatus={loading ? "validating" : null}
          rules={[
            {
              type: "email",
              message: "email is not valid!",
            },
            {
              required: true,
              message: "Enter your email address",
            },
          ]}
        >
          <Input
            type="email"
            onChange={(e) => validateEmail(e)}
            className={`emailInputSignUp ${
              greenCheck && !passwordValidation
                ? "validInputCSS"
                : `${showCheckIconEmail ? "notValidInput" : null}`
            }`}
            loading={true}
            id="SignInField"
            placeholder="Enter your email"
            suffix={
              greenCheck && !passwordValidation ? (
                <>
                  {!loading ? <img src={GreenCheck} alt="greenCheck" /> : null}
                </>
              ) : (
                <>
                  {showCheckIconEmail ? (
                    <>
                      {!loading ? (
                        <GoAlert
                          style={{
                            color: "#db2828",
                            marginRight: "0.4rem",
                          }}
                        />
                      ) : null}
                    </>
                  ) : null}
                </>
              )
            }
          />
        </Form.Item>
        <Form.Item
          name="password"
          help={
            passwordValidation ? (
              <div className="notValidColor">
                Incorrect username or password. Try again
              </div>
            ) : null
          }
          rules={[
            {
              required: true,
              message: "Enter your password",
            },
          ]}
        >
          <Input.Password
            // name="password"
            rules={[
              // {
              //   pattern: /^\S{8,}$/,
              //   message: "please use a valid password",
              // },
              {
                required: true,
              },
            ]}
            onChange={validatePassword}
            className={`passwordSignUp ${
              passwordValidation ? "notValidInput" : null
            } `}
            id="SignInField"
            placeholder="Password"
            iconRender={(visible) =>
              visible ? (
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: 500,
                    fontStretch: "normal",
                    fontStyle: "normal",
                    lineHeight: "normal",
                    letterSpacing: "normal",
                    textAlign: "right",
                    color: "#4054b2",
                  }}
                >
                  Hide
                </span>
              ) : (
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: 500,
                    fontStretch: "normal",
                    fontStyle: "normal",
                    lineHeight: "normal",
                    letterSpacing: "normal",
                    textAlign: "right",
                    color: "#4054b2",
                  }}
                >
                  Show
                </span>
              )
            }
          />
        </Form.Item>
        <Form.Item>
          <Button
            onClick={() => {
              ReactGA.event({
                category: "User Interaction",
                action: APP_NAME.EMPLOYER + " " + EVENTS.SIGN_IN_BUTTON_CLICK,
                label: "Signup Button",
              });

              dispatch(
                userClicked({
                  uuid: uuid,
                  event: EVENTS.SIGN_IN_BUTTON_CLICK,
                  pageType: PAGE_TYPE.SIGNIN,
                  page: PAGE.MODAL,
                  appName: APP_NAME.EMPLOYER,
                  url: window?.location?.pathname,
                })
              );
            }}
            type="primary"
            htmlType="submit"
            className="login-form-button"
            disabled={loading}
            style={{ marginBottom: "0.7rem" }}
          >
            <span style={{ fontSize: "1rem" }}>Sign in</span>
          </Button>
        </Form.Item>
        <Form.Item className="remeberForgotWRAP">
          <Form.Item
            name="remember"
            valuePropName="checked"
            noStyle
            className="remember-checkbox"
          >
            <input
              onChange={remember}
              type="checkbox"
              defaultChecked={false}
              className="Checkbox"
              checked={isremember}
            />
            <div className="rememberForgotCSS">
              <span>Remember me</span>
            </div>
          </Form.Item>
          <a
            className="forgotPassCSS"
            onClick={forgetpassword}
            style={{ marginTop: "0.15rem" }}
          >
            Forgot password?
          </a>
        </Form.Item>
      </Form>
      <Modal
        bodyStyle={{ padding: "10px" }}
        width="24.37rem"
        visible={isModalVisibleForgotAuth}
        closable={false}
        footer={null}
        onCancel={modalCancel}
        maskClosable={true}
        centered={true}
        destroyOnClose={true}
        destroyPopupOnHide={true}
      >
        <LostPassword
          lostPassToLogin={lostPassToLogin}
          backClick={backClicked}
        />
        <div className="bottom-text" onClick={() => modalCancel()}>
          Back to sign in
        </div>
      </Modal>
    </div>
  );
};

export default Login;
